var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockOutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.9,54.8c-1.3-1.5-2.7-2.9-4.1-4.6c3-2.6,6-5.1,8.4-7.2C77.3,77,112,111.7,146.7,146.4c-2.1,1.8-5,4.5-8.3,7.4 c0.7,0.1,0.2,0.1,0.1,0c-3.2-4.3-5.8-3.8-10.3-0.9C96,174.7,35.5,166.8,25.2,108C22,89.7,26.3,73,37.1,57.9 c0.5-0.7,1.1-1.5,1.6-2.2C38.7,55.6,38.7,55.5,38.9,54.8z M122.9,140.2c-25-25-49.9-50-74.9-75c-15.2,17.3-16.6,49.9,5.2,71.1 C74.9,157.2,107.5,154.5,122.9,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1,40.4c23.6-14.9,57.7-12.7,80.2,9.5c23.3,22.9,25.1,57.1,10.6,81.5c-2.6-2.9-5.2-5.4-7.3-8.3c-0.7-1.1-0.6-3.4,0-4.7 c12.2-30.4-4-63.8-35.6-72.7c-11.3-3.2-22.6-2.7-33.5,1.7c-3.9,1.6-6.5,1.5-9-1.8C61.2,43.6,59.3,42.2,57.1,40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,22.5c12.5-8.4,30.4-5.7,40.9,5.5c10.2,10.8,12.1,28.6,3.9,39.2C156.7,46.4,141.9,31.6,120.9,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,67.4c-8.2-12.5-6.1-29.2,4.4-40.1c10.5-10.7,27.4-13,40.4-5C39.8,31.6,24.8,46.2,15.8,67.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOutIcon);
export default __webpack_public_path__ + "static/media/ClockOutIcon.391ba589.svg";
export { ForwardRef as ReactComponent };